import moment from 'moment/moment'

export const deepCopyObject = (obj = {}) => JSON.parse(JSON.stringify(obj))

export const parseJson = (str, defaultValue = null) => {
  try {
    return JSON.parse(str)
  } catch (e) {
    return defaultValue
  }
}

export const getDiffDays = date => {
  const oneDay = 24 * 60 * 60 * 1000
  const firstDate = new Date()
  const secondDate = new Date(date)

  return Math.round(Math.abs((firstDate - secondDate) / oneDay))
}

export const getDiffTime = date => {
  if (date) {
    const now = moment(new Date())
    const then = moment(new Date(date))
    const ms = now.diff(then)
    return AddSecToMs(ms, 0)
  }
  return {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    ms: 0
  }
}

export const AddSecToMs = (ms, sec = 1) => {
  const newMs = ms + sec * 1000
  const hours = moment.duration(newMs).hours()
  const minutes = moment.duration(newMs).minutes()
  const seconds = moment.duration(newMs).seconds()
  const days = Math.floor(moment.duration(newMs).asDays())
  return {
    days,
    hours,
    minutes,
    seconds,
    ms: newMs
  }
}
export const isObject = variable => {
  return (
    typeof variable === 'object' &&
    variable !== null &&
    !Array.isArray(variable)
  )
}

export const clearObject = data =>
  Object.keys(data).reduce((acc, key) => {
    if (data[key] && Array.isArray(data[key]) && data[key]?.length > 0) {
      acc[key] = data[key]
    }
    if (
      data[key] &&
      typeof data[key] !== 'boolean' &&
      !Array.isArray(data[key])
    ) {
      acc[key] = data[key]
    }
    if (typeof data[key] === 'boolean') {
      acc[key] = data[key]
    }

    return acc
  }, {})

export const bytesToMB = bytes => {
  if (bytes === 0) return '0 MB'

  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(bytes) / Math.log(1024))

  return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`
}
